export const DataFieldNames = {
  name: 'name',
};
